
import React, { Component } from 'react';

import { FormContext } from 'core/FormProvider';
import { ContextWidget } from 'form/Contexed';
import { InputWidget, InputNumberWidget } from 'form/InputWidget';
import { CheckboxWidget } from 'form/Checkbox';
import FormGroup from 'form/FormGroup';
import { Grid } from 'ui/Grid';


export class SemiTrailerForm extends Component {

  render() {
    return (
      <FormContext.Consumer>
        {() => {
          return (
            <FormGroup>
              <div className={'mb-15'}>
                <ContextWidget
                  name={'is_active'}
                  WidgetComponent={CheckboxWidget}
                  widgetProps={{
                    label: 'Активность'
                  }}
                />
              </div>
              <ContextWidget
                name={'number'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Регистрационный знак',
                  required: true,
                  toUpperCase: true
                }}
              />
              <ContextWidget
                name={'brand'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Марка'
                }}
              />
              <ContextWidget
                name={'model'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Модель'
                }}
              />
              <ContextWidget
                name={'year'}
                WidgetComponent={InputNumberWidget}
                widgetProps={{
                  label: 'Год выпуска'
                }}
              />
              <ContextWidget
                name={'portal_weight'}
                WidgetComponent={InputNumberWidget}
                widgetProps={{
                  label: 'Портальный вес (кг)'
                }}
              />
              <Grid columns={'1fr 1fr 1fr'}>
                <ContextWidget
                  name={'width'}
                  WidgetComponent={InputNumberWidget}
                  widgetProps={{
                    label: 'Ширина'
                  }}
                />
                <ContextWidget
                  name={'height'}
                  WidgetComponent={InputNumberWidget}
                  widgetProps={{
                    label: 'Высота'
                  }}
                />
                <ContextWidget
                  name={'length'}
                  WidgetComponent={InputNumberWidget}
                  widgetProps={{
                    label: 'Длина'
                  }}
                />
              </Grid>
              <ContextWidget
                name={'description'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Описание',
                  multiline: true
                }}
              />
            </FormGroup>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
